export const GET_INSIGHTS_REQUEST = "GET_INSIGHTS_REQUEST";
export const SET_INSIGHTS_REQUEST = "SET_INSIGHTS_REQUEST";
export const SET_BOOKS_REQUEST = "SET_BOOKS_REQUEST";
export const GET_BOOKS_REQUEST = "GET_BOOKS_REQUEST";
